import React from 'react';

import { Card, Typography } from 'antd';

import clsx from 'clsx';
import PermissionHide from 'v2/components/Shared/PermissionHide';

import { Icon } from '@eduzz/ui-antd-theme';

import { Link } from './Link';

type ReportIcon = typeof Icon.UserRoundCheck;

interface CardProps {
  title: string;
  subtitle: string;
  link: string;
  icon: ReportIcon;
  disabled?: boolean;
  permission?: string;
  userTypes?: string[];
  allowWithoutPermission?: boolean;
}

const cards: CardProps[] = [
  {
    title: 'Comissões pagas a afiliados',
    subtitle: 'Verifique quanto você já pagou de comissão a seus afiliados.',
    link: '/producer/reports/sales/commissions/affiliates',
    icon: Icon.Users,
    permission: 'myeduzz:reports:visualizar'
  },
  {
    title: 'Comissões pagas a parceiros',
    subtitle: 'Verifique quanto você já pagou de comissão a seus parceiros (coprodutores).',
    link: '/producer/reports/sales/commissions/partners',
    icon: Icon.Handshake,
    permission: 'myeduzz:reports:visualizar'
  },
  {
    title: 'Reembolsos',
    subtitle: 'Confira os reembolsos realizados em suas vendas.',
    link: '/producer/reports/sales/refunds',
    icon: Icon.Undo2,
    permission: 'myeduzz:reports:visualizar'
  },
  {
    title: 'Motivos de cancelamento e suspensão',
    subtitle: 'Saiba porque seus contratos têm sido cancelados ou suspensos.',
    link: '/producer/reports/sales/cancel',
    icon: Icon.Ban,
    permission: 'myeduzz:reports:visualizar'
  },
  {
    title: 'Chargebacks',
    subtitle: 'Gerencie os chargebacks solicitados pelos clientes.',
    link: '/producer/chargebacks',
    icon: Icon.CreditCard,
    permission: 'myeduzz:chargeback:visualizar',
    userTypes: ['producer']
  },
  {
    title: 'Sugerir novo relatório',
    subtitle: 'Vote em qual será o próximo relatório a ser disponibilizado ou sugira um novo relatório',
    link: 'https://surveys.hotjar.com/f9ad4cec-c6be-458b-921a-b85083ee27cb',
    icon: Icon.Lightbulb,
    allowWithoutPermission: true
  }
];

export const Cards = () => {
  return (
    <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3'>
      {cards.map(card => {
        const ReportIcon = card.icon;

        return (
          <PermissionHide
            allowWithoutPermission={card.allowWithoutPermission}
            userTypes={card.userTypes}
            action={card.permission}
            key={card.title}
          >
            <Link link={card.link} className='group block h-full'>
              <Card
                className={clsx(
                  'h-full rounded-(--uizz-antd-border-radius-lg) transition-[background-color,border-color] duration-200',
                  card.disabled
                    ? 'pointer-events-none opacity-50'
                    : 'group-hover:border-(--uizz-antd-color-primary) group-hover:bg-(--uizz-antd-color-primary-bg)'
                )}
                classNames={{ body: 'p-(--uizz-antd-padding-lg)' }}
              >
                <div className='flex flex-col gap-4'>
                  <ReportIcon size={28} className='text-(--uizz-antd-color-primary)' />
                  <div className='flex flex-col gap-2'>
                    <Typography.Title level={5} className='mb-0'>
                      {card.title}
                    </Typography.Title>
                    <Typography.Text type='secondary'>{card.subtitle}</Typography.Text>
                  </div>
                </div>
              </Card>
            </Link>
          </PermissionHide>
        );
      })}
    </div>
  );
};
